export default __webpack_public_path__ + "static/13(1)-f97139f70c127c0e43c1fce4f04cc19e.png";